<template>
  <div
    ref="announcementBar"
    class="announcement-bar"
  >
    <swiper
      class="announcement-bar__slides"
      :modules="modules"
      :allow-touch-move="false"
      loop
      auto-height
      :autoplay="{
        delay: announcementBar.slideDelay,
        disableOnInteraction: false,
        enabled: announcementBar.enabled,
        pauseOnMouseEnter: true,
      }"
    >
      <swiper-slide
        v-for="(announcement, index) of announcementBar.announcements"
        :key="index"
        class="announcement-bar__slide"
      >
        <span
          v-if="announcement.title"
          class="announcement-bar__title"
          v-html="announcement.title"
        />
        <span
          v-if="announcement.content"
          class="announcement-bar__content"
          v-html="announcement.content"
        />
      </swiper-slide>
    </swiper>

    <btn
      v-if="showNewsletterButton"
      class="
        newsletter-popup__cta
        newsletter-popup__cta-desktop
      "
      :show-icon="false"
      :label="$string('general.newsletter_popup.cta')"
      @click="toggleOverlay({
        component: 'newsletter-popup',
        ignoreDismissed: true,
        namespace: 'newsletterPopup',
      })"
    />
  </div>
</template>

<script>

/**
 * Vue: Announcement bar (announcement-bar)
 * -----------------------------------------------------------------------------
 * Announcement Bar.
 *
 * @param {Object} announcementBar - Object with announcement bar settings.
 *
 */
import { Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { mapActions, mapState } from 'vuex'
import classes from '~/config/classes'

import Btn from '~global/btn/btn'

export default {
  name: 'AnnouncementBar',

  components: {
    Btn,
    Swiper,
    SwiperSlide,
  },

  props: {
    announcementBar: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },

  setup() {
    return {
      modules: [Autoplay],
    }
  },

  data() {
    return {
      global: true,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Check local storage to see if newsletter form has been submitted.
     * @returns {Boolean}
     */
    emailPopupSuccess() {
      const success = localStorage.getItem('emailPopupSuccess')

      if (success) {
        return true
      }

      return false
    },

    /**
     * Check to see if newsletter button should be shown.
     * @returns {Boolean}
     */
    showNewsletterButton() {
      if (
        !this.isMobile &&
        !this.emailPopupSuccess &&
        this.announcementBar.newsletterEnabled
      ) {
        return true
      }

      return false
    },
  },

  mounted() {
    if (this.announcementBar.static) {
      return
    }

    window.addEventListener('scroll', this.togglePromoBannerHide)
    this.togglePromoBannerHide()
  },

  unmounted() {
    if (this.announcementBar.static) {
      return
    }

    window.removeEventListener('scroll', this.togglePromoBannerHide)
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      toggleOverlay: 'overlays/toggle',
    }),

    /**
     * Adding hidden class to the announcement bar on scroll
     */
    togglePromoBannerHide() {
      const announcementBarHeight = this.$refs.announcementBar.offsetHeight

      if (window.scrollY > announcementBarHeight) {
        this.$refs.announcementBar.classList.add(classes.hidden)

        return
      }

      this.$refs.announcementBar.classList.remove(classes.hidden)
    },
  },
}
</script>
